import { ComponentProps } from '@stitches/react'
import { Avatar } from 'common/Avatar'
import { Link } from 'common/Link'
import { AppRoutes } from 'config/routes'
import { useHandlePayment } from 'hooks/useHandlePayment'
import { useStore } from 'lib/store'
import { theme } from 'lib/theme'
import { NSFW_EVENT } from 'lib/tracking/types'
import { observer } from 'mobx-react-lite'
import { Post } from 'models/Post'
import { useRouter } from 'next/router'
import { Box } from 'primitives/Box'
import { Flex } from 'primitives/Flex'
import { forwardRef } from 'react'
import { AvatarGroup } from '../AvatarGroup'
import { PostAssetsCarousel } from '../PostAssetsCarousel'
import { PostBottomBar } from './components/BottomBar'
import { PostCaption } from './components/PostCaption'
import { PostTopBar } from './components/TopBar'

// ....
export interface PostCardProps extends ComponentProps<typeof Box> {
  post: Post
  showTopMenu?: boolean
  descMaxLines?: number
}

export const VerticalLine = () => {
  return (
    <Box
      css={{
        borderLeft: `1px solid ${theme.colors.gray600}`,
        width: 'fit-content',
        height: '83%',
        position: 'relative',
        top: '10px',
        left: '15px'
      }}
    />
  )
}

const _PostCard = forwardRef<HTMLDivElement, PostCardProps>(
  ({ css, post, showTopMenu = true }, ref) => {
    const store = useStore()

    const { handlePayment } = useHandlePayment({ post })

    const handleAssetClick = () => {
      store.feed.setSelectedPost(post)
      store.ui.openPostModal()
    }
    const profilePath = `${AppRoutes.PROFILE}/${post.profile?.username}`

    const handleClickPostProfile = () => {
      store.analytics.track(NSFW_EVENT.FEED_POST_PROFILE_VIEW, {
        feedType: post.feedType,
        page: post.feedPage,
        postId: post.postId,
        profileId: post.profile!.profileId,
        username: post.profile!.username
      })
    }

    return (
      <Flex
        ref={ref}
        css={{
          backgroundColor: theme.colors.gray300,
          borderRadius: '6px',

          ...css
        }}
      >
        <Flex
          css={{
            flexDirection: 'column',
            width: '10%',
            paddingLeft: '10px',
            paddingTop: '25px'
          }}
        >
          <Link nounderline href={profilePath} onClick={handleClickPostProfile}>
            <Avatar
              src={post?.profile?.avatar?.url}
              username={store.user.account?.username}
              size="small"
              css={{ cursor: 'pointer' }}
            />
          </Link>
          {post.assets.length <= 2 ? <VerticalLine /> : null}
          {post.assets.length <= 2 ? <AvatarGroup /> : null}
          {/* {post.assets.length <= 2 ? (
            <Flex css={{ flexDirection: 'column' }}>
              <VerticalLine /> <AvatarGroup />
            </Flex>
          ) : null} */}
        </Flex>
        <Flex
          css={{
            flexDirection: 'column',
            width: '100%',
            paddingLeft: '10px'
          }}
        >
          <PostTopBar
            post={post}
            css={{
              display: showTopMenu ? 'flex' : 'none'
            }}
          />
          <PostCaption post={post} />
          <PostAssetsCarousel post={post} onClick={handleAssetClick} />
          <PostBottomBar post={post} handlePayment={handlePayment} />
        </Flex>
      </Flex>
    )
  }
)

_PostCard.displayName = 'PostCard'

export const PostCard = observer(_PostCard)
